import { render, staticRenderFns } from "./MypagePointExpirationDateTableSection.vue?vue&type=template&id=6e43821c&scoped=true"
import script from "./MypagePointExpirationDateTableSection.vue?vue&type=script&lang=ts"
export * from "./MypagePointExpirationDateTableSection.vue?vue&type=script&lang=ts"
import style0 from "./MypagePointExpirationDateTableSection.vue?vue&type=style&index=0&id=6e43821c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e43821c",
  null
  
)

export default component.exports